import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { DICTS } from "@/lib/i18n";

export const Route = createFileRoute("/account/applications")({
  component: lazyRouteComponent(() => import("./-pages/account.applications")),
  head: () => ({
    meta: [
      { title: DICTS.en["account.applications.meta_title"] ?? "Upgrade application — Lecmo" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});
